// 登录回调容错页：正常 OAuth 回调由服务端 /api/auth/lark/callback 处理并直接跳回站内；
// 本页兜底处理带 error 参数或异常落点的情况，读 URL 参数容错。

import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Spinner } from "@bf/ui";

export function LoginCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [failed, setFailed] = useState(false);

  const error = params.get("error");
  const redirect = params.get("redirect") ?? params.get("state") ?? "/";
  const safeRedirect = redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/";

  useEffect(() => {
    if (error) {
      setFailed(true);
      return;
    }
    // 无错误参数：刷新会话后回跳（cookie 已由服务端设置）
    void refresh().then(() => navigate(safeRedirect, { replace: true }));
  }, [error, refresh, navigate, safeRedirect]);

  if (failed) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f6f7] p-4">
        <div className="w-full max-w-sm rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
          <h1 className="text-base font-medium text-gray-900">登录失败</h1>
          <p className="mt-2 text-sm text-gray-500">{error ? decodeURIComponent(error) : "登录流程异常，请重试"}</p>
          <Link to="/login" className="mt-6 inline-block text-sm text-brand hover:text-brand-hover">
            重新登录
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f5f6f7]">
      <div className="flex items-center gap-2 text-sm text-gray-400">
        <Spinner size="sm" />
        登录处理中…
      </div>
    </div>
  );
}
